import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import { Container, Content, Title, SemanticTable } from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const HistoriasDeSucessoListar = (props) => {
  const [historias, setHistorias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    loadHistorias();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadHistorias = async () => {
    await api
      .get(`/pessoa/depoimento`)
      .then(async (res) => {
        let array = {
          local: "historiaDeSucesso",
          texto: `listou as Historias`,
        };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        setHistorias(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar as Historias", err, "error");
      });
  };
  const removeHistoria = useCallback(
    (idHistoria) => {
      swal(
        "Remoção de historia",
        "Você tem certeza que quer remover? ",
        ""
      ).then(async (res) => {
        if (res) {
          api.delete(`pessoa/depoimento/${idHistoria}`).then(async (res) => {
            let array = {
              local: "historiaDeSucesso",
              texto: `deletou a Historia de id=${idHistoria}`,
            };
            await api.post("system_logs", { acao: JSON.stringify(array) });
            const newHistorias = [...historias].filter(
              (historia) => historia.id !== idHistoria
            );
            setHistorias(newHistorias);
          });
        }
      });
    },
    [historias]
  );

  const verifyTreinamento = (value) => {
    if (value == null) {
      return "esse treinamento não existe";
    } else {
      return value.nome;
    }
  };

  const verifyCategorie = (value) => {
    if (value == null) {
      return "essa categoria não existe";
    } else {
      return value.name;
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Histórias de sucesso</Title>
            <Link to="/admindev/HistoriasDeSucesso/criar">
              <Button>Criar</Button>
            </Link>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    Nome depointe
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    Treinamento
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    Categoria
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    Link da midia
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              {historias.length > 0 ? (
                <SemanticTable.Body>
                  {historias.map((historia, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{historia.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{historia.nome}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {verifyTreinamento(historia.treinamento)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {verifyCategorie(historia.categorie)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {historia.link_media}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <>
                          <Button
                            icon="edit icon"
                            color={"blue"}
                            onClick={() =>
                              window.open(
                                `HistoriasDeSucesso/detalhes/${historia.id}`
                              )
                            }
                          />

                          <Button
                            icon="trash icon"
                            color={"red "}
                            onClick={() => removeHistoria(historia.id)}
                          />
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
                </SemanticTable.Body>
              ) : (
                <h3>Nenhuma Historia encontrada</h3>
              )}
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(HistoriasDeSucessoListar);
